<div *ngIf="isMobile; else webLogin" class="full-container">
  More actions
  <div class="buytokens-container">
    <div class="top-content">
      <div class="tokens-info-mobile">
        <div class="instruction-mobile">
          Please enter the number of tokens you wish to buy
        </div>
      </div>
      <div *ngIf="isLoading" class="loading-mobile">
        Adding tokens to your wallet, please wait...
      </div>
      <div class="form-container-mobile">
        <form [formGroup]="modalForm">
          <div class="tokens-form-box">
            <div class="form-group-mobile">
              <div class="form-label-mobile">
                Enter Number of Tokens (1 Token = 1₹)
              </div>
              <input
                type="number"
                id="token_amount"
                class="form-control-mobile"
                formControlName="token_amount"
              />
              <div
                *ngIf="
                  token_amount?.invalid &&
                  (token_amount?.dirty || token_amount?.touched)
                "
              >
                <div
                  class="error-mobile"
                  *ngIf="token_amount?.errors?.['required']"
                >
                  Token amount is required.
                </div>
                <div
                  class="error-mobile"
                  *ngIf="!token_amount?.errors?.['nonNegative'] && token_amount?.errors?.['min']"
                >
                  Token amount must be greater than 0.
                </div>
              </div>
            </div>
          </div>
        </form>
        <div *ngIf="errorMessage" class="error-mobile">
          {{ errorMessage }}
        </div>
      </div>
    </div>

    <div class="bottom-content">
      <div class="cancel-and-submit-buttons">
        <div class="cancel-button-mobile">
          <button (click)="onCancel()" [disabled]="isLoading">Cancel</button>
        </div>
        <div class="submit-button-mobile">
          <button
            type="submit"
            (click)="submit()"
            type="submit"
            [disabled]="!modalForm.valid || isLoading"
          >
            Buy
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #webLogin>
  <div class="buytokens-container">
    <div class="form-container">
      <div class="form-header">
        Please enter the number of tokens you wish to buy
      </div>
      <div *ngIf="isLoading" class="loading-web">
        Adding tokens to your wallet, please wait...
      </div>
      <form [formGroup]="modalForm">
        <div class="form-group">
          <div class="form-field">
            <div class="form-label">Enter Number of Tokens (1 Token = 1₹)</div>
            <input
              type="number"
              id="token_amount"
              class="form-control"
              formControlName="token_amount"
            />
            <div
              *ngIf="
                token_amount?.invalid &&
                (token_amount?.dirty || token_amount?.touched)
              "
            >
              <div class="error" *ngIf="token_amount?.errors?.['required']">
                Token amount is required.
              </div>
              <div
                class="error"
                *ngIf="!token_amount?.errors?.['nonNegative'] && token_amount?.errors?.['min']"
              >
                Token amount must be greater than 0.
              </div>
            </div>
            <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>
          </div>
          
        </div>
      </form>
      <div class="form-actions">
        <button type="button" (click)="onCancel()">Cancel</button>
        <button
          (click)="submit()"
          type="submit"
          [disabled]="!modalForm.valid"
          [ngClass]="{
            'not-allowed': !modalForm.valid,
            pointer: modalForm.valid
          }"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>
